var render = function render(){
  var _vm$data, _vm$data$productDetai, _vm$data2, _vm$data2$productDeta;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-12 col-sm-12 col-xs-12 pr12"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "row border-top-light-blue"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "row txt-center p50 bg-white"
  }, [_vm._v(" Loading... ")]) : _vm._e()]) : _c('div', {
    staticClass: "row border-top-light-blue"
  }, [_c('div', {
    staticClass: "p20 navbar-sticky",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "font18",
    staticStyle: {
      "font-weight": "600 !important",
      "margin": "0px 4px 0px 4px"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left pointer",
    staticStyle: {
      "margin-right": "18px",
      "cursor": "pointer"
    },
    attrs: {
      "title": "Back"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push(`/catalog/product?branchId=${_vm.branchId}`);
      }
    }
  }), _vm._v(" Product ")])]), _vm.isLoading ? _c('div', {
    staticClass: "row txt-center p50 bg-white"
  }, [_vm._v(" Loading... ")]) : (_vm$data = _vm.data) !== null && _vm$data !== void 0 && (_vm$data$productDetai = _vm$data.productDetail) !== null && _vm$data$productDetai !== void 0 && _vm$data$productDetai.id ? _c('div', {
    staticClass: "row bg-white p24"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "6px",
      "display": "grid",
      "margin-bottom": "10px"
    }
  }, [_c('b', [_vm._v("Select Branch")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchId,
      expression: "branchId"
    }],
    staticStyle: {
      "min-width": "calc(50% - 20px)",
      "width": "fit-content"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.branchId = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, function ($event) {
        return _vm.getProductDetail(_vm.data.productDetail.id, _vm.branchId);
      }]
    }
  }, _vm._l(_vm.branches, function (brand, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": brand.id
      }
    }, [_vm._v(" " + _vm._s(brand.name) + " ")]);
  }), 0)]), _vm.data.productDetail ? _c('ProductGeneral', {
    attrs: {
      "productDetail": _vm.data.productDetail,
      "branchId": _vm.branchId
    },
    on: {
      "createProductGeneral": _vm.createProductGeneralListener
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "row txt-center p50 bg-white"
  }, [_vm._v("product not found")]), (_vm$data2 = _vm.data) !== null && _vm$data2 !== void 0 && (_vm$data2$productDeta = _vm$data2.productDetail) !== null && _vm$data2$productDeta !== void 0 && _vm$data2$productDeta.id ? _c('ListVaraintOption', {
    attrs: {
      "id": _vm.data.productDetail.id,
      "branchId": _vm.branchId
    }
  }) : _vm._e()], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }